const config = {
  csc_client_id: process.env.CSC_CLIENT_ID || 'missing',
  csc_client_callback_url: process.env.CSC_CLIENT_CALLBACK_URI || 'missing',
  csc_connect_server_uri: process.env.CSC_CONNECT_SERVER_URI || 'https://connectuat.csccloud.in'
};

export default config;
